var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telegram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3749 10.8481C8.74359 8.50908 12.3236 6.96703 14.1148 6.22199C19.2292 4.09475 20.2919 3.72522 20.9846 3.71302C21.1369 3.71034 21.4776 3.74809 21.6982 3.92713C21.8845 4.07831 21.9358 4.28253 21.9603 4.42587C21.9848 4.5692 22.0154 4.89572 21.9911 5.15085C21.714 8.06288 20.5147 15.1296 19.9046 18.3912C19.6465 19.7712 19.1382 20.234 18.6461 20.2792C17.5766 20.3777 16.7645 19.5725 15.7287 18.8935C14.1078 17.831 13.1921 17.1696 11.6188 16.1328C9.80053 14.9346 10.9792 14.276 12.0155 13.1997C12.2866 12.9181 16.9987 8.63209 17.0899 8.24329C17.1013 8.19466 17.1119 8.0134 17.0042 7.91769C16.8965 7.82198 16.7376 7.85471 16.6229 7.88074C16.4604 7.91763 13.871 9.6291 8.85486 13.0151C8.11988 13.5198 7.45416 13.7657 6.8577 13.7528C6.20015 13.7386 4.93528 13.3811 3.99498 13.0754C2.84166 12.7005 1.92503 12.5023 2.00485 11.8656C2.04642 11.534 2.5031 11.1948 3.3749 10.8481Z",
    fill: "#070A26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.e638eefcbfd58f8ef98b7ce3002a00af.svg";
export { ForwardRef as ReactComponent };